var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container closures-container"},[_c('global-header'),_c('closures-body')],1)}
var staticRenderFns = []

export { render, staticRenderFns }